export default "__VITE_ASSET__3M63CG2J__"